export interface Alert {
  message: string;
  type: AlertTypeEnum;
}

export enum AlertTypeEnum {
  ERROR = 'ERROR',
  SUCESS = 'SUCCESS',
  WARNING = 'WARNING',
  INFO = 'INFO',
}
